import axios from "axios"

export function getOrderDetail (id) {
  return new Promise((resolve, reject) => {
    axios.get(`/distributor/admin/api/v1/stock-order/${id}`)
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response.data))
  });
};